import React, { useState, useEffect } from 'react';
import api from '../services/api';

const ConnectionStatus = () => {
  const [isConnected, setIsConnected] = useState(false);

  const checkConnection = async () => {
    try {
      const status = await api.getConnectionStatus();
      setIsConnected(status.status === 'connected');
    } catch (error) {
      console.error('Connection check failed:', error);
      setIsConnected(false);
    }
  };

  useEffect(() => {
    // Initial check
    checkConnection();
    
    // Check every 1 minute (60 seconds)
    const interval = setInterval(checkConnection, 60000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center">
      <div 
        className={`w-2.5 h-2.5 rounded-full ${isConnected ? '' : 'bg-red-500'}`}
        style={{
          backgroundColor: isConnected ? 'rgb(0, 255, 94)' : undefined,
          animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
        }}
        title={isConnected ? 'Connected to MySQL Database' : 'MySQL Database Disconnected'}
      />
    </div>
  );
};

export default ConnectionStatus;